import MapComponent from './MapComponent.jsx';
import './MapComponent.css';

export default MapComponent;
